import { render, staticRenderFns } from "./SelectSpecialityOrDoctorStep.vue?vue&type=template&id=767b54d0&scoped=true"
import script from "./SelectSpecialityOrDoctorStep.vue?vue&type=script&lang=js"
export * from "./SelectSpecialityOrDoctorStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767b54d0",
  null
  
)

export default component.exports